import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChanges';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';

/**
 * Mapping Klickdummy-Sidebar-Icons → MUI-Outlined-Icons.
 * Auswahl orientiert an den inline-SVGs des Klickdummys
 * (packages/ui/upl/sms_pm_crud_v3_9.html Zeile 1290+).
 */
export const PROJECT_SIDEBAR_ICONS: Record<string, ComponentType<SvgIconProps>> = {
  dashboard: DashboardOutlinedIcon,
  stakeholders: PeopleAltOutlinedIcon,
  machbarkeit: AssignmentTurnedInOutlinedIcon,
  rahmen: GridViewOutlinedIcon,
  projektauftrag: DescriptionOutlinedIcon,
  ziele: TrackChangesOutlinedIcon,
  zeiten: AccessTimeOutlinedIcon,
  team: GroupsOutlinedIcon,
  unsicherheiten: HelpOutlineOutlinedIcon,
  anforderungen: PlaylistAddCheckOutlinedIcon,
  scope: ArticleOutlinedIcon,
  arbeitspakete: ViewListOutlinedIcon,
  projektplan: TimelineOutlinedIcon,
  risiken: WarningAmberOutlinedIcon,
  meetings: CalendarMonthOutlinedIcon,
  'offene-punkte': StickyNote2OutlinedIcon,
  kanban: ViewKanbanOutlinedIcon,
  burnup: ShowChartOutlinedIcon,
  status: SummarizeOutlinedIcon,
  retro: ReplayOutlinedIcon,
  abschluss: FlagOutlinedIcon,
};
